import { Component, onMount } from 'solid-js'
import { useNavigate } from '@solidjs/router'

type PaymentSuccessProps = {
  type?: 'tokens' | 'subscription'
}

const PaymentSuccess: Component<PaymentSuccessProps> = (props) => {
  const navigate = useNavigate()

  onMount(() => {
    // Send message to parent window after 3 seconds
    setTimeout(() => {
      const messageType = props.type === 'subscription' ? 'subscription-success' : 'payment-success'
      window.parent.postMessage({ type: messageType }, '*')
    }, 3000)
  })

  const message = () => {
    return props.type === 'subscription'
      ? 'Your subscription will be activated shortly.'
      : 'Your tokens will be added to your account shortly.'
  }

  return (
    <div class="flex h-screen w-full flex-col items-center justify-center bg-main p-4 text-center">
      <h1 class="mb-4 text-2xl font-bold">Payment Successful!</h1>
      <p class="text-gray-300">{message()}</p>
      <p class="mt-4 text-sm text-gray-400">This window will close automatically...</p>
    </div>
  )
}

export default PaymentSuccess
